import { render, staticRenderFns } from "./WithdrawWalletView.vue?vue&type=template&id=df4fd050&scoped=true&"
import script from "./WithdrawWalletView.vue?vue&type=script&lang=ts&"
export * from "./WithdrawWalletView.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawWalletView.vue?vue&type=style&index=0&id=df4fd050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4fd050",
  null
  
)

export default component.exports